import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalVariable } from '../../app/Variable/global-variable';
import { CommonService } from '../Global-Services/common.service';
import { Location } from '@angular/common';
import { AppTokenHandler } from '../Global-Services/app-token-handler';
import { LoginService } from './login.service';
import { environment } from 'src/environments/environment';
import { AppInsightsService } from './app-insights.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGaurdService {

  AppRoles = [];
  referralURL: string;
  isRole: boolean;
  href: string;
  userDetails: any;
  RedirectLogin: string;

  constructor(private route: Router, private gservice: CommonService, private gVariable: GlobalVariable
    , private _location: Location, private tokenHandler: AppTokenHandler, private activeRoute: ActivatedRoute,private appInsightsService : AppInsightsService,
    private loginService: LoginService, ) {
      this.route.events.forEach((event) => {
        if (event instanceof NavigationEnd) {
            this.LogPageAnalytics();
        }
    });
    }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    this.loginService.redirectUrl = state.url;
    const expectedRoles = route.data['expectedRole'];
    const isUserLoggedIn = this.tokenHandler.isLoggedIn;
    this.userDetails = this.tokenHandler.getLoginUserInfo();
    if (this.userDetails !=null && this.userDetails._ApplicationRole != null) {
      this.AppRoles = this.userDetails._ApplicationRole.split(',');
    }
    else {
      this.AppRoles = [];
    }

      if (((this.AppRoles.indexOf('Admin') > -1) || (this.AppRoles.indexOf('IsCounsellor') > -1) || (this.AppRoles.indexOf('IsPartner') > -1)
        || (this.AppRoles.indexOf('IsSLHR') > -1) || (this.AppRoles.indexOf('IsFinanceTeam') > -1)) ||
      (this.AppRoles.indexOf('Admin1') > -1) || (this.AppRoles.indexOf('IsManager') > -1) ||
      (this.AppRoles.indexOf('IsPartner') > -1) || (this.AppRoles.indexOf('BUOUSpoc') > -1) ) {
        this.isRole = true;
      }
    if (!isUserLoggedIn) {
      sessionStorage.setItem('redirectUrl', state.url);
      this.route.navigate(['/']);
      return false;
    } else {
      if (!this.isRole) {
        this.route.navigate(['/error/4']);
        return false;
      } else {
        return true;
      }
    }
  }

  SetSessionAndNavigate(loginData, url) {
    this.tokenHandler.setSessionToken(loginData);
    this.activeRoute.queryParams.subscribe(params => {
      this.referralURL = url;
      if (this.referralURL == null) {
        this.route.navigate(['/INFTE/home']);
      } else {
        this.route.navigate([this.referralURL]);
        this.referralURL = null;
      }
    });
  }

  Logout() {
    this.gVariable.mainMenuVisiable = false;
    this.route.navigate(['/logout']);
  }

  LogPageAnalytics() {
    if (environment.logApplicationInsights == 'Y') {
      const username = this.tokenHandler.getLoginUserInfo(); // Replace with actual username retrieval logic
      if(username != null && username.UserGPN != '')
      this.appInsightsService.trackPageView(window.location.href.replace('#/', ''), username.UserGPN);
    }
}
}
